/**-For building url params of features-**/
const buildParam = (name, value, andSign = true) => value ? `${andSign ? "&" : ''}${name}=` + value : ''

export { buildParam }